// Metadata for Avento blog articles.
// Shared by BlogPage (listing cards) and BlogArticlePage (hero + SEO lookup).
// The article prose bodies live in BlogArticlePage/articles and are wired to a
// slug inside BlogArticlePage, so they are only loaded in the article chunk.

const IMG = '/static/images/blog';

// When adding an article: add its body in BlogArticlePage's ARTICLE_BODIES map
// and its path to defaultPublicPaths in server/resources/sitemap.js (the sitemap
// hardcodes paths, matching every other static route in that file).
export const BLOG_ARTICLES = [
  {
    slug: 'when-to-buy-your-own-skydiving-gear',

    cardTitle: 'When to Buy Your Own Skydiving Gear',
    cardDescription:
      'Owning beats renting from around 20 jumps a year. What both options really cost, what to buy first, why your first rig should be used, and when waiting is smarter.',
    cardImage: `${IMG}/when-to-buy-your-own-skydiving-gear-card.webp`,

    hero: {
      title: 'Owning vs. Renting',
      subtitle: 'When to buy your own skydiving gear',
      desktopImage: `${IMG}/when-to-buy-your-own-skydiving-gear-hero-desktop.webp`,
      desktopWidth: 3273,
      desktopHeight: 704,
      mobileImage: `${IMG}/when-to-buy-your-own-skydiving-gear-hero-mobile.webp`,
      mobileWidth: 780,
      mobileHeight: 571,
    },

    metaTitle: 'Owning vs. Renting: When to buy your own skydiving gear',
    metaDescription:
      'Buying or renting comes down to how often you jump, what canopy you fly and your rental options. On cost alone, owning wins from around 20 jumps a year.',
    // Dedicated 1200x630 social image (the desktop hero is mostly black canvas)
    ogImage: {
      url: `${IMG}/when-to-buy-your-own-skydiving-gear-og.jpg`,
      width: 1200,
      height: 630,
    },
    author: "Avento's Lean Stein",
    datePublished: '2026-09-07',
    dateModified: '2026-09-07',
  },
  {
    slug: 'where-to-buy-used-skydiving-gear',

    cardTitle: 'Where to Buy Used Skydiving Gear',
    cardDescription:
      'Facebook groups, riggers, eBay, local sales and Avento compared on price, safety, selection and scam risk, so you know where to look for your next gear.',
    cardImage: `${IMG}/where-to-buy-used-skydiving-gear-card.webp`,

    hero: {
      title: 'Where to Buy Used Skydiving Gear',
      subtitle: '5 Options Compared',
      desktopImage: `${IMG}/where-to-buy-used-skydiving-gear-hero-desktop.webp`,
      desktopWidth: 3274,
      desktopHeight: 704,
      mobileImage: `${IMG}/where-to-buy-used-skydiving-gear-hero-mobile.webp`,
      mobileWidth: 780,
      mobileHeight: 571,
    },

    metaTitle: 'Where to Buy Used Skydiving Gear: 5 Options Compared',
    metaDescription:
      'Where to buy used skydiving gear: Facebook groups, riggers, eBay, local sales and Avento compared on price, safety and selection.',
    // Dedicated 1200x630 social image (the desktop hero is mostly black canvas)
    ogImage: {
      url: `${IMG}/where-to-buy-used-skydiving-gear-og.jpg`,
      width: 1200,
      height: 630,
    },
    author: "Avento's Lean Stein",
    datePublished: '2026-09-03',
    dateModified: '2026-09-03',
  },
  {
    slug: 'understanding-listing-analytics-on-avento',

    // Listing card (blog articles get no label overlay, unlike resource cards)
    cardTitle: 'Understanding Your Listing Analytics',
    cardDescription:
      'Views, impressions, saves, click rate, performance rating. What each number on your listing means, and how to use them to sell your gear faster.',
    cardImage: `${IMG}/blog-analytics-card.webp`,

    // Hero: title + subtitle are overlaid on a text-free image and scaled in cqw
    // (same technique as the home/fees hero), so they stay sharp and reflow per width.
    hero: {
      title: 'Seller Analytics on Avento',
      subtitle: 'What Your Listing Views, Impressions, and Saves Tell You',
      desktopImage: `${IMG}/blog-analytics-hero-desktop.webp`,
      desktopWidth: 3024,
      desktopHeight: 700,
      mobileImage: `${IMG}/blog-analytics-hero-mobile.webp`,
      mobileWidth: 780,
      mobileHeight: 780,
    },

    // SEO
    metaTitle: 'Understanding Your Listing Analytics on Avento | Avento Blog',
    metaDescription:
      'A clear guide to your Avento listing analytics: what views, impressions, saves, click rate and performance rating mean, and how to use them to sell your skydiving gear faster.',
    author: "Avento's Lean Stein",
    datePublished: '2026-06-25',
    dateModified: '2026-06-25',
  },
];

export const getArticleBySlug = slug =>
  BLOG_ARTICLES.find(article => article.slug === slug) || null;
